import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Offcanvas, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { portalEdit } from "../../redux/actions/portalAction";
import errorToast from "../../components/toast/errorToast";

/**Edit Portal Module */
const EditPortal = ({ show, onHide, portalData, reloadData }) => {
  const dispatch = useDispatch();
  const [portalName, setPortalName] = useState(portalData?.portal_name)

  const handleEdit = () => {
    dispatch(
      portalEdit({ id: portalData.id, portal_name: portalName }, onSuccess, onError)
    );
  };

  const onSuccess = (data) => {
    onHide();
    reloadData()
  };

  const onError = (error) => {
    errorToast(error.message);
  };

  const handleInputChange = (e) => {
    setPortalName(e.target.value);
  };

  return (
    <Offcanvas backdrop="static" show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Edit Portal</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group controlId="formUser">
          <Form.Label>Portal Name</Form.Label>
          <Form.Control
            type="text"
            name="portal_name"
            value={portalName}
            onChange={handleInputChange}
            placeholder={portalName || "Enter portal name"}
          />
        </Form.Group>
        <div className="d-flex gap-4 mt-4 px-4">
          <button type="button" className="btn btn-primary btn-action" onClick={handleEdit}>
            Save
          </button>
          <button type="button" className="btn btn-secondary" onClick={onHide}>
            Cancel
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default EditPortal;
